"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _theme = _interopRequireDefault(require("../../../../theme"));
const useStyles = (0, _core.makeStyles)({
  giftCardForm: {
    marginTop: '34px'
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    [_theme.default.breakpoints.down('sm')]: {
      marginTop: '30px',
      '&:first-child': {
        marginTop: '0'
      }
    },
    '&.input-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: "".concat(_theme.default.palette.error.main, " !important"),
        borderWidth: '1px'
      }
    },
    '&.securityCode': {
      paddingLeft: '40px',
      '& .inputBox': {
        width: '84px',
        marginRight: '0'
      },
      '&.inputWrapper': {
        flexBasis: '0'
      },
      [_theme.default.breakpoints.down('lg')]: {
        paddingLeft: '20px'
      },
      [_theme.default.breakpoints.down('md')]: {
        paddingLeft: '0'
      },
      [_theme.default.breakpoints.down('sm')]: {
        paddingLeft: '10px'
      }
    }
  },
  inputBox: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiOutlinedInput-input': {
      color: _theme.default.palette.grayScale.dark,
      fontFamily: _theme.default.typography.proxima.regular,
      padding: '15px 0 15px 20px',
      '&::-webkit-input-placeholder': {
        color: _theme.default.palette.grayScale.placeholder,
        opacity: '1'
      },
      '&:-ms-input-placeholder': {
        color: _theme.default.palette.grayScale.placeholder,
        opacity: '1'
      },
      '&::placeholder': {
        color: _theme.default.palette.grayScale.placeholder,
        opacity: '1'
      },
      [_theme.default.breakpoints.down('sm')]: {
        padding: '15px 10px 15px 10px'
      }
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: _theme.default.palette.primary.light,
          borderWidth: '1px'
        }
      },
      '& .Mui-disabled': {
        color: _theme.default.palette.grayScale.disabled
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: _theme.default.palette.grayScale.lightShadow
        }
      }
    }
  },
  errorMessage: {
    color: _theme.default.palette.error.main,
    fontSize: '12px',
    paddingTop: '10px',
    '&.no-padding-top': {
      paddingTop: '0'
    }
  },
  dateSelectInput: {
    flexGrow: '1',
    color: _theme.default.palette.grayScale.dark,
    '&:first-child': {
      marginRight: '5px'
    },
    '&:last-child': {
      marginLeft: '5px'
    },
    '& svg': {
      color: _theme.default.palette.primary.light
    },
    '&.input-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: "".concat(_theme.default.palette.error.main, " !important"),
        borderWidth: '1px'
      }
    },
    '& .MuiSelect-select': {
      '&:focus': {
        backgroundColor: 'transparent'
      }
    }
  },
  selectDefaultValue: {
    '& .MuiSelect-select': {
      color: _theme.default.palette.grayScale.placeholder,
      fontFamily: _theme.default.typography.proxima.regular
    }
  },
  inputLabel: {
    fontSize: _theme.default.typography.pxToRem(14),
    color: _theme.default.palette.grayScale.lowMiddleLight,
    marginBottom: '9px'
  },
  inputBoxWrapper: {
    display: 'flex',
    '& .inputBox': {
      width: '285px',
      marginRight: '40px'
    },
    '& .dateSelectInput': {
      width: '145px',
      '&:last-child': {
        width: '120px',
        [_theme.default.breakpoints.down('lg')]: {
          width: '90px'
        }
      }
    },
    '&:last-child': {
      marginTop: '30px'
    },
    [_theme.default.breakpoints.down('lg')]: {
      '& .inputBox': {
        width: '240px',
        marginRight: '20px'
      },
      '& .dateSelectInput': {
        width: '120px'
      },
      '& .inputWrapper': {}
    },
    [_theme.default.breakpoints.down('md')]: {
      '& .inputWrapper': {
        '&:first-child': {
          marginRight: '40px'
        },
        '&:last-child': {
          marginLeft: '0'
        }
      },
      '& .inputBox': {
        width: '240px',
        marginRight: '0'
      },
      '& .dateSelectInput': {
        width: '120px'
      }
    },
    [_theme.default.breakpoints.down('sm')]: {
      display: 'block',
      '& .inputWrapper': {
        '&:first-child': {
          marginRight: '0'
        },
        '&:last-child': {
          marginLeft: '0'
        }
      },
      '& .inputBox': {
        width: '295px'
      },
      '& .dateSelectInput': {
        width: '101px'
      }
    }
  },
  expirationAndSecurityCodeWrapper: {
    display: 'flex',
    [_theme.default.breakpoints.down('sm')]: {
      marginTop: '24px',
      display: 'flex',
      '& .securityCode': {
        marginTop: '0'
      }
    }
  }
});
var _default = exports.default = useStyles;